import $ from 'jquery';

const archiveItemsAPI = (pageIds, folderIds, suggestionIds, externalResourceIds, questionIds, documentIds) => {
    const url = `/api/teams/${window.teamId}/categories/${window.categoryId}`;
    const type = 'PUT';
    const action = 'archive';
    return $.ajax({
        url,
        type,
        data: {
            action, pageIds, folderIds, suggestionIds, externalResourceIds, questionIds, documentIds,
        },
    });
};

const moveItemsAPI = (destCategoryId, destFolderId, pageIds, folderIds, suggestionIds, externalResourceIds, questionIds, documentIds) => {
    const url = `/api/teams/${window.teamId}/categories/${window.categoryId}`;
    const type = 'PUT';
    const action = 'move';
    return $.ajax({
        url,
        type,
        data: {
            action, destCategoryId, destFolderId, pageIds, folderIds, suggestionIds, externalResourceIds, questionIds, documentIds,
        },
    });
};

const moveItemsToNewFolderAPI = (destCategoryId, newFolderName, pageIds, folderIds, suggestionIds, externalResourceIds, questionIds, documentIds) => {
    const url = `/api/teams/${window.teamId}/categories/${window.categoryId}`;
    const type = 'PUT';
    const action = 'move';
    return $.ajax({
        url,
        type,
        data: {
            action, destCategoryId, newFolderName, pageIds, folderIds, suggestionIds, externalResourceIds, questionIds, documentIds,
        },
    });
};

const moveItemsToNewCategoryAPI = (newCategoryName, pageIds, folderIds, suggestionIds, externalResourceIds, questionIds, documentIds) => {
    const url = `/api/teams/${window.teamId}/categories/${window.categoryId}`;
    const type = 'PUT';
    const action = 'move';
    return $.ajax({
        url,
        type,
        data: {
            action, newCategoryName, pageIds, folderIds, suggestionIds, externalResourceIds, questionIds, documentIds,
        },
    });
};

export {
    archiveItemsAPI, moveItemsAPI, moveItemsToNewFolderAPI, moveItemsToNewCategoryAPI,
};
